import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import KlassyAvatar from "../klassyAvatar/KlassyAvatar";
import "./KlassyDisclaimer.scss";

const KlassyDisclaimer: FC = () => {
  const { t } = useTranslation("annotationSideControls", {
    keyPrefix: "alert.exportFailed.moreDetails",
  });

  return (
    <div className="klassy-disclaimer">
      <KlassyAvatar />
      <div className="klassy-disclaimer__text">
        <span className="klassy-disclaimer__label">{t("klassyLabel")}</span>
        <span className="klassy-disclaimer__sub">{t("aiDisclaimer")}</span>
      </div>
    </div>
  );
};

export default KlassyDisclaimer;
